require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/$.core').Number.isNaN;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-nan.js
// module id = 988
// module chunks = 0